import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=dbc09758&scoped=true&"
import script from "./CallUs.vue?vue&type=script&lang=js&"
export * from "./CallUs.vue?vue&type=script&lang=js&"
import style0 from "./CallUs.vue?vue&type=style&index=0&id=dbc09758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc09758",
  null
  
)

export default component.exports